const CHUNK_ERROR_PATTERN =
  /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module|ChunkLoadError/i

const isChunkLoadError = err =>
  CHUNK_ERROR_PATTERN.test(err?.message || "") || err?.name === "ChunkLoadError"

export const loadPageComponent = async page => {
  const pages = import.meta.glob("../pages/**/*.page.jsx")

  // Controllers now send bare names, but during a deploy a client-side
  // navigation can hit an old pod that still returns a ".page"-suffixed name
  // while this (new) bundle is running. Strip the suffix so both resolve.
  // TODO: remove once the bare-name controllers have fully rolled out.
  const name = page.replace(/\.page$/, "")

  const pageFn =
    pages[`../pages/${name}.page.jsx`] ||
    pages[`../pages/${name}/index.page.jsx`]

  if (typeof pageFn !== "function") {
    throw new Error(`Page component not found: ${page}`)
  }

  try {
    return await pageFn()
  } catch (err) {
    if (!isChunkLoadError(err)) throw err

    // Stale chunk after a deploy: the hashed JS file the user's session is
    // trying to import no longer exists on the CDN. Reload once to pick up
    // the current manifest. SessionStorage guards against an infinite loop
    // if the chunk is genuinely broken.
    const reloadKey = `chunk-reload:${page}`
    if (
      typeof sessionStorage !== "undefined" &&
      !sessionStorage.getItem(reloadKey)
    ) {
      sessionStorage.setItem(reloadKey, "1")
      window.location.reload()
      return new Promise(() => {})
    }
    throw err
  }
}
